import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteSimpleStepItem } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";

export function useDeleteSimpleStepItem() {
    const queryClient = useQueryClient();

    const { mutate: deleteItemMutate, isPending } = useMutation({
        mutationFn: deleteSimpleStepItem,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete simple step item");
        },
    });

    return { deleteItemMutate, isPending };
}
